import { invoke } from '@shared/easyfy.decorators';
import { globalEvent, element } from '@shared/easyfy.core';
import formService from '@inlineServices/form.service';
import easyfyToaster, { MessageSeverity } from '@shared/easyfy.toaster';
import { isValidEmail } from '@webModules/validateHelper';

namespace Easyfy.Web.Pages {
  @invoke
  class CreateAccount {
    static Instance: CreateAccount;

    static formContainerElement: HTMLElement;

    constructor() {
      CreateAccount.Instance = this;
    }

    onInit() {
      globalEvent({
        type: 'submit',
        event: {
          action: 'send-activate-account-mail',
          callback: CreateAccount.SendActivateAccountMail
        }
      });
      CreateAccount.formContainerElement = element(
        '[data-container="form"]'
      ) as HTMLElement;
    }

    static SendActivateAccountMail = async (e: Event) => {
      e.preventDefault();
      e.stopPropagation();

      const DATA_MESSAGE_ATTRIBUTE = 'data-message';
      const ACTION_ATTRIBUTE = 'action';
      const NAME_ATTRIBUTE = 'email';

      const form = e.target as HTMLFormElement;
      const formData = new FormData(form);

      const email = formData.get(NAME_ATTRIBUTE);

      const messageContainerName =
        form.getAttribute(DATA_MESSAGE_ATTRIBUTE) || '';
      const messageContainer = form.querySelector(
        `[data-container="${messageContainerName}"]`
      ) as HTMLElement;
      const submitButton = form.querySelector(
        'button[name="submitButton"]'
      ) as HTMLButtonElement;
      const submitButtonText = submitButton.innerHTML as string;

      const toggleButtonState = (
        button: HTMLButtonElement,
        loading: boolean
      ) => {
        button.disabled = loading;
        button.innerHTML = loading
          ? '<div class="loader" role="status" aria-live="polite" aria-label="Laddar"></div>'
          : submitButtonText;
      };

      const validEmail = isValidEmail(email.toString());
      if (!validEmail) {
        easyfyToaster.toaster(
          MessageSeverity.error,
          'Epostadressen har felaktigt format.',
          messageContainer
        );
        toggleButtonState(submitButton, false);
        return;
      }

      try {
        toggleButtonState(submitButton, true);

        const response = await formService.PostForm(
          form.getAttribute(ACTION_ATTRIBUTE) || '',
          formData
        );

        CreateAccount.formContainerElement.innerHTML = response.data.partial;

      } catch (error) {
        easyfyToaster.toaster(
          MessageSeverity.error,
          'Något gick fel.',
          messageContainer
        );
        toggleButtonState(submitButton, false);
      }
    };
  }
}

export default Easyfy.Web.Pages;
